/* THE SKILLS RECOVERY CONSOLE V1.3 */
(() => {
  if (window.__skillsRecoveryConsoleV13Ready) return;
  window.__skillsRecoveryConsoleV13Ready = true;

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let internalCartRequest = false;

  async function fetchSections() {
    const response = await fetch(
      `${rootUrl()}?sections=cart-drawer,cart-icon-bubble`,
      { headers: { Accept: 'application/json' } }
    );

    if (!response.ok) throw new Error('Could not refresh the Recovery Console.');
    return response.json();
  }

  function replaceSectionHTML(html, selector, currentSelector) {
    if (!html) return false;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector(selector);
    const current = document.querySelector(currentSelector);

    if (!source || !current) return false;

    current.innerHTML = source.innerHTML;
    return true;
  }

  async function refreshConsole({ open = true } = {}) {
    const previousScoreElement = document.querySelector(
      '.skills-console-score[data-recovery-score]'
    );
    const previousScore = previousScoreElement
      ? Number(previousScoreElement.dataset.recoveryScore || 0)
      : null;

    const sections = await fetchSections();

    replaceSectionHTML(
      sections['cart-drawer'],
      '#CartDrawer',
      '#CartDrawer'
    );

    replaceSectionHTML(
      sections['cart-icon-bubble'],
      '.shopify-section',
      '#shopify-section-cart-icon-bubble'
    );

    const drawer = document.querySelector('cart-drawer');

    if (drawer) {
      if (typeof drawer.bindOverlay === 'function') drawer.bindOverlay();
      if (open && typeof drawer.open === 'function') drawer.open();
    }

    document.dispatchEvent(
      new CustomEvent('skills:console_refreshed', {
        bubbles: true,
        detail: { previousScore }
      })
    );
  }

  async function changeLine(line, quantity, sellingPlan) {
    internalCartRequest = true;

    try {
      const payload = { line, quantity };

      if (sellingPlan !== undefined) {
        payload.selling_plan = sellingPlan || null;
      }

      const response = await fetch(`${rootUrl()}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result?.description ||
          result?.message ||
          'Could not update the cart.'
        );
      }

      await refreshConsole({ open: true });
    } finally {
      internalCartRequest = false;
    }
  }

  async function addProduct(button) {
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING';
    internalCartRequest = true;

    try {
      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result?.description ||
          result?.message ||
          'Could not add product.'
        );
      }

      await refreshConsole({ open: true });
    } catch (error) {
      console.error('[RECOVERY CONSOLE ADD]', error);
      window.alert(error.message);
      button.disabled = false;
      button.textContent = original;
    } finally {
      internalCartRequest = false;
    }
  }

  async function changeSellingPlan(input) {
    const line = Number(input.dataset.line);
    const quantity = Number(input.dataset.quantity || 1);
    const sellingPlan = input.value ? Number(input.value) : null;

    if (!line) return;
    await changeLine(line, quantity, sellingPlan);
  }

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('[data-console-add]');

    if (addButton) {
      event.preventDefault();
      await addProduct(addButton);
      return;
    }

    const removeButton = event.target.closest('[data-console-remove]');

    if (removeButton) {
      event.preventDefault();
      const line = Number(removeButton.dataset.line);
      if (line) await changeLine(line, 0);
      return;
    }

    const minusButton = event.target.closest('[data-console-quantity-minus]');

    if (minusButton) {
      event.preventDefault();

      const line = Number(minusButton.dataset.line);
      const item = minusButton.closest('.skills-console-item');
      const input = item?.querySelector('.quantity__input');
      const currentQuantity = Number(input?.value || 1);
      const nextQuantity = Math.max(0, currentQuantity - 1);

      if (line) await changeLine(line, nextQuantity);
      return;
    }

    const plusButton = event.target.closest('[data-console-quantity-plus]');

    if (plusButton) {
      event.preventDefault();

      const line = Number(plusButton.dataset.line);
      const item = plusButton.closest('.skills-console-item');
      const input = item?.querySelector('.quantity__input');
      const currentQuantity = Number(input?.value || 1);

      if (line) await changeLine(line, currentQuantity + 1);
    }
  });

  document.addEventListener('change', async (event) => {
    const planInput = event.target.closest('[data-console-plan]');

    if (planInput) {
      await changeSellingPlan(planInput);
      return;
    }

    const quantityInput = event.target.closest(
      '.skills-console-item .quantity__input'
    );

    if (quantityInput) {
      const line = Number(quantityInput.dataset.index);
      const quantity = Math.max(0, Number(quantityInput.value || 0));

      if (line) await changeLine(line, quantity);
    }
  });

  /*
    Reset all visual state after closing so the underlying page is fully restored.
  */
  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest(
      '.skills-console-close, #CartDrawer-Overlay'
    );

    if (!closeTrigger) return;

    window.setTimeout(() => {
      const drawer = document.querySelector('cart-drawer');

      if (drawer && !drawer.classList.contains('active')) {
        drawer.classList.remove('animate');
        drawer.removeAttribute('style');
      }

      document.body.classList.remove(
        'overflow-hidden',
        'skills-console-open'
      );

      document.documentElement.classList.remove('overflow-hidden');
    }, 360);
  });

  /*
    Auto open after external Ajax add to cart calls.
  */
  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const requestUrl =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';

      const isCartAdd =
        requestUrl.includes('/cart/add') ||
        requestUrl.includes('cart/add.js');

      if (isCartAdd && response.ok && !internalCartRequest) {
        window.clearTimeout(window.__skillsConsoleAutoOpenTimer);

        window.__skillsConsoleAutoOpenTimer = window.setTimeout(() => {
          refreshConsole({ open: true }).catch((error) => {
            console.error('[RECOVERY CONSOLE AUTO OPEN]', error);
          });
        }, 140);
      }
    } catch (error) {
      console.error('[RECOVERY CONSOLE FETCH WATCH]', error);
    }

    return response;
  };


  /*
    Bundler app integration.

    Bundler officially emits:
    product:added
    bndlr:bundle_added_to_cart
    bundler:total_cart_values
  */
  const openAfterBundlerUpdate = () => {
    window.clearTimeout(window.__skillsBundlerConsoleTimer);

    window.__skillsBundlerConsoleTimer = window.setTimeout(() => {
      refreshConsole({ open: true }).catch((error) => {
        console.error('[RECOVERY CONSOLE BUNDLER]', error);
      });
    }, 160);
  };

  document.addEventListener('product:added', openAfterBundlerUpdate);
  document.addEventListener('bndlr:bundle_added_to_cart', openAfterBundlerUpdate);

  document.addEventListener('bundler:total_cart_values', (event) => {
    const detail = event.detail || {};
    const original = Number(detail.total_amount_original || 0);
    const discounted = Number(detail.total_amount_discounted || 0);
    const discount = Number(detail.discount_amount || 0);

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD'
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    document.querySelectorAll('.bundler-cart-total-original').forEach((element) => {
      element.textContent = original > 0 ? formatMoney(original) : '';
      if (discount > 0) {
        element.style.textDecoration = 'line-through';
      } else {
        element.style.textDecoration = '';
      }
    });

    document.querySelectorAll('.bundler-cart-total-discounted').forEach((element) => {
      element.textContent =
        discount > 0 && discounted > 0
          ? formatMoney(discounted)
          : '';
    });

    document.querySelectorAll('.bundler-cart-discount-value-no-minus').forEach((element) => {
      element.textContent = formatMoney(discount);
    });

    document.body.classList.toggle('bundler-discount-active', discount > 0);
  });






  /*
    Stable hover intent for desktop reveals.
    A short delay prevents opening and closing as the pointer crosses nested
    elements. Click and tap continue to work through native details behavior.
  */
  function bindStableRevealIntent() {
    const recoveryIndex = document.querySelector(
      '.skills-console-score--expandable'
    );

    if (
      !recoveryIndex ||
      recoveryIndex.dataset.stableRevealBound === 'true'
    ) {
      return;
    }

    recoveryIndex.dataset.stableRevealBound = 'true';

    let openTimer = null;
    let closeTimer = null;

    recoveryIndex.addEventListener('pointerenter', () => {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      window.clearTimeout(closeTimer);
      openTimer = window.setTimeout(() => {
        recoveryIndex.open = true;
      }, 180);
    });

    recoveryIndex.addEventListener('pointerleave', () => {
      if (window.matchMedia('(max-width: 749px)').matches) return;

      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(() => {
        recoveryIndex.open = false;
      }, 320);
    });

    recoveryIndex.addEventListener('toggle', () => {
      window.clearTimeout(openTimer);

      if (recoveryIndex.open) {
        window.clearTimeout(closeTimer);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', bindStableRevealIntent);
  document.addEventListener('skills:console_refreshed', bindStableRevealIntent);

  /*
    Recovery points integration layer.

    This event is app agnostic. A future loyalty or rewards app adapter can
    listen for skills:recovery_points_updated without changing drawer logic.
  */
  function publishRecoveryPoints() {
    const scoreElement = document.querySelector(
      '.skills-console-score[data-recovery-score]'
    );

    if (!scoreElement) return;

    const score = Number(scoreElement.dataset.recoveryScore || 0);
    const level = scoreElement.dataset.recoveryLevel || 'RESET';

    document.dispatchEvent(
      new CustomEvent('skills:recovery_points_updated', {
        bubbles: true,
        detail: {
          score,
          level,
          source: 'recovery-console'
        }
      })
    );
  }

  function animateRecoveryScore(previousScore = null) {
    const scoreElement = document.querySelector(
      '.skills-console-score[data-recovery-score]'
    );

    if (!scoreElement) return;

    const finalScore = Number(scoreElement.dataset.recoveryScore || 0);
    const numberElement = scoreElement.querySelector(
      '.skills-console-score__number strong'
    );

    if (!numberElement) {
      publishRecoveryPoints();
      return;
    }

    const startingScore =
      previousScore === null
        ? Number(numberElement.textContent || finalScore)
        : Number(previousScore);

    const duration = 420;
    const startTime = performance.now();

    scoreElement.classList.add('is-score-updating');

    const tick = (now) => {
      const progress = Math.min(1, (now - startTime) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.round(
        startingScore + (finalScore - startingScore) * eased
      );

      numberElement.textContent = String(value);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        numberElement.textContent = String(finalScore);
        window.setTimeout(() => {
          scoreElement.classList.remove('is-score-updating');
        }, 100);
        publishRecoveryPoints();
      }
    };

    requestAnimationFrame(tick);
  }

  document.addEventListener('skills:console_refreshed', (event) => {
    animateRecoveryScore(event.detail?.previousScore ?? null);
  });

  document.addEventListener('DOMContentLoaded', () => {
    publishRecoveryPoints();
  });





  function bindConnectedThresholdSystem() {
    const systems = document.querySelectorAll('[data-threshold-system]');

    systems.forEach((system) => {
      if (system.dataset.connectedThresholdBound === 'true') return;
      system.dataset.connectedThresholdBound = 'true';

      const triggers = Array.from(
        system.querySelectorAll('[data-threshold-trigger]')
      );
      const panels = Array.from(
        system.querySelectorAll('[data-threshold-panel]')
      );

      let activeTier = null;
      let openTimer = null;
      let closeTimer = null;

      const isMobile = () =>
        window.matchMedia('(max-width: 749px)').matches;

      const getTrigger = (tier) =>
        triggers.find((trigger) => trigger.dataset.thresholdTrigger === tier);

      const getPanel = (tier) =>
        panels.find((panel) => panel.dataset.thresholdPanel === tier);

      const closeTier = (tier = activeTier) => {
        if (!tier) return;

        const trigger = getTrigger(tier);
        const panel = getPanel(tier);

        if (trigger) {
          trigger.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
        }

        if (panel) {
          panel.hidden = true;
          panel.classList.remove('is-active');
        }

        if (activeTier === tier) activeTier = null;
      };

      const openTier = (tier) => {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);

        if (activeTier && activeTier !== tier) {
          closeTier(activeTier);
        }

        const trigger = getTrigger(tier);
        const panel = getPanel(tier);

        if (!trigger || !panel) return;

        activeTier = tier;
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.classList.add('is-active');
      };

      const scheduleOpen = (tier) => {
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);

        openTimer = window.setTimeout(() => {
          openTier(tier);
        }, 170);
      };

      const scheduleClose = (tier) => {
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          const trigger = getTrigger(tier);
          const panel = getPanel(tier);

          const pointerStillInside =
            trigger?.matches(':hover') ||
            panel?.matches(':hover');

          if (!pointerStillInside) {
            closeTier(tier);
          }
        }, 340);
      };

      triggers.forEach((trigger) => {
        const tier = trigger.dataset.thresholdTrigger;

        trigger.addEventListener('pointerenter', () => {
          if (isMobile()) return;
          scheduleOpen(tier);
        });

        trigger.addEventListener('pointerleave', () => {
          if (isMobile()) return;
          scheduleClose(tier);
        });

        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (activeTier === tier) {
            closeTier(tier);
          } else {
            openTier(tier);
          }
        });
      });

      panels.forEach((panel) => {
        const tier = panel.dataset.thresholdPanel;

        panel.addEventListener('pointerenter', () => {
          if (isMobile()) return;
          window.clearTimeout(closeTimer);
        });

        panel.addEventListener('pointerleave', () => {
          if (isMobile()) return;
          scheduleClose(tier);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindConnectedThresholdSystem);
  document.addEventListener(
    'skills:console_refreshed',
    bindConnectedThresholdSystem
  );

})();